// extracted by mini-css-extract-plugin
module.exports = {"cardmsgA":"cardmsgA_cardmsgA__EBRR2"};